<template>
<div v-if="checklistLoaded">
    <v-app-bar
      outlined
      flat
      color="white"
      height="60px"
      style="border-bottom: 1px solid #EDEDED !important;"
    >
      <IconTooltipButtonBottom
          icon="mdi-arrow-left"
          tooltip="Zurück zur Liste"
          id="default"
          width="50px"
          large
          @click="$router.go(-1)"
      />
      <v-spacer></v-spacer>
      <v-toolbar-title>{{ currentChecklist.name }}</v-toolbar-title>
      <div>
      </div>
      <v-spacer class="spacer-light"></v-spacer>
      <v-card flat outlined class="survey-group mr-4">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn v-if="currentChecklist.mod1surveyId == -1" plain @click="connectSurvey(1)"
                   class="btn-small text-start" v-bind="attrs" v-on="on">
              <v-icon color="error">mdi-clipboard-remove-outline</v-icon>
              {{decodeModuleNameByNumber(1)}} <span class="text-emp">*</span>
            </v-btn>
            <v-btn v-else plain @click="openConnectedSurvey(currentChecklist.mod1surveyId.toString())"
                   class="btn-small pr-0"
                   v-bind="attrs" v-on="on">
              <v-icon color="success">mdi-clipboard-check-outline</v-icon>
              {{decodeModuleNameByNumber(1)}} <span class="text-emp">*</span>
            </v-btn>
          </template>
          <span>Umfrage <br/> {{decodeModuleNameByNumber(1)}} (benötigt)</span>
        </v-tooltip>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn v-if="currentChecklist.mod2surveyId == -1" plain @click="connectSurvey(2)" class="btn-small text-start" v-bind="attrs" v-on="on">
              <v-icon color="disabled">mdi-clipboard-remove-outline</v-icon>
              {{decodeModuleNameByNumber(2)}}
            </v-btn>
            <v-btn v-else plain @click="openConnectedSurvey(currentChecklist.mod2surveyId.toString())" class="btn-small"
                   v-bind="attrs" v-on="on">
              <v-icon color="success">mdi-clipboard-check-outline</v-icon>
              {{decodeModuleNameByNumber(2)}}
            </v-btn>
          </template>
          <span>Umfrage <br/> {{decodeModuleNameByNumber(2)}} (optional)</span>
        </v-tooltip>
      </v-card>
      <v-btn @click="saveChecklist" color="primary" elevation="0">
        <v-icon class="mr-1">mdi-content-save</v-icon> Speichern
      </v-btn>
    </v-app-bar>
    <ConnectedSurveyEval ref="ConnectedSurveyEval" />
    <v-container v-if="checklistLoaded" id="mainFrame">
      <h1>Einführung einer digitalen Technologie im Betrieb</h1>
      <v-stepper v-model="e1" flat>
          <v-stepper-header class="bg-gray stepper-nav">
            <div v-for="index in currentChecklist.listSchema.length-1" :key="index">
              <v-stepper-step
                :complete="e1 > index"
                :step="getLabel(index)"
              >
                {{ stepTitle[index-1] }}
              </v-stepper-step>
            </div>
          </v-stepper-header>
          <v-stepper-items>
            <v-stepper-content v-for="indx in currentChecklist.listSchema.length-1" :step="indx" :key="indx">
              <div v-if="showEvaluation" style="height: fit-content">
                <PXSurveyEvaluationPage :surveyIdProp="currentChecklist.mod1surveyId.toString()" />
                <v-btn
                    color="secondary"
                    elevation="0"
                    @click="hideEvaluation()"
                  >
                    Weiter
                  </v-btn>
              </div>
              <div v-else>
                <StepPage :schema="currentChecklist.listSchema[e1]" />
                <div class="btn-group__bottom px-4 py-6">
                  <v-btn
                      text
                      :disabled="e1 == 1"
                      @click="backStep()">
                    Zurück
                  </v-btn>
                  <v-tooltip v-if="completionCount < 100 || currentChecklist.mod1surveyId == -1" top>
                    <template v-slot:activator="{ on, attrs }">
                      <div style="display:inline" v-bind="attrs" v-on="on">
                        <v-btn
                            color="secondary"
                            elevation="0"
                            :disabled="completionCount < 100 || currentChecklist.mod1surveyId == -1"
                            @click="nextStep()"
                        >
                          Weiter
                        </v-btn>
                      </div>
                    </template>
                    <span v-if="currentChecklist.mod1surveyId == -1">Um fortfahren zu können, müssen Sie eine Umfrage aus dem Bindungsmodul verknüpfen. Dies können Sie über den Button "Umfrage Bindungsmodul (benötigt)" in der rechten oberen Ecke tun.</span>
                    <span v-if="completionCount < 100 && currentChecklist.mod1surveyId != -1">Um den aktuellen Schritt abzuschließen, müssen alle Fragen auf "Vollständig erledigt" gesetzt sein. Den aktuellen Status zeigt Ihnen die Ampel am rechten Bildschirmrand. Ist diese Grün, können Sie fortfahren.</span>
                  </v-tooltip>
                  <v-btn
                      v-else
                      elevation="0"
                      color="secondary"
                      @click="nextStep()"
                  >
                    Weiter
                  </v-btn>
                </div>
              </div>
            </v-stepper-content>
          </v-stepper-items>
      </v-stepper>
    </v-container>
    <v-snackbar
        v-model="snackbar" timeout="3000" class="mb-12"
    >
      Speichern erfolgreich
    </v-snackbar>
    <v-tooltip left>
      <template v-slot:activator="{ on, attrs }">
        <div v-bind="attrs" v-on="on" class="trLight">
          <div class="trLight-wrapper">
            <span class="dot" :style="'background-color:'+getRed"></span><br/>
            <span class="dot" :style="'background-color:'+getYellow"></span><br/>
            <span class="dot" :style="'background-color:'+getGreen"></span>
          </div>
          <InfoboxTooltip ref="infoBox_1"/>
        </div>
      </template>
      <span>Die abgebildete Ampel zeigt Ihren aktuellen Status der Checkliste. Haben Sie unter 60% der Inhalte bearbeitet, ist der Status Rot. Bei über 60% wird der Status Gelb und bei 100% Grün. Sie können erst bei einem grünen Status in die nächste Phase wechseln.</span>
    </v-tooltip>
    
    <ShowEvaluationDialog ref="evalDialog" />
    <ConfirmDialog ref="confirmDialog" />
    <ConnectSurveyToChecklistDialog ref="connectDialog" />
</div>
</template>

<script>
import StepPage from "./ChecklistSteps/StepPage.vue";

import checklistGenerator from "@/components/checklistGenerator.js";
import checklistService from "./checklist-service";
import ConfirmDialog from "../../components/common/ConfirmDialog.vue";
import InfoboxTooltip from "../../components/common/InfoboxTooltip.vue";
import IconTooltipButtonBottom from "../../components/common/IconTooltipButtonBottom.vue";
import surveyService from "@/pages/PxQuestionSurvey/PXSurveyPage/px-survey-service";
import ShowEvaluationDialog from "./ShowEvaluationDialog.vue";
import ConnectedSurveyEval from "./ConnectedSurveyEval.vue";
import PXSurveyEvaluationPage from "@/pages/PxQuestionSurvey/PXSurveyPage/Evaluation/PXSurveyEvaluationPage.vue";
import ConnectSurveyToChecklistDialog from "./ConnectSurveyToChecklistDialog.vue";
import {decodeModuleNameByNumber} from '@/components/util.js'
  export default {
    components:{
      StepPage,
      ConfirmDialog,
      ShowEvaluationDialog,
      PXSurveyEvaluationPage,
      InfoboxTooltip,
      IconTooltipButtonBottom,
      ConnectSurveyToChecklistDialog,
      ConnectedSurveyEval
},
    data () {
      return {
        e1: 1,
        currentChecklist: {},
        checklistLoaded: false,
        snackbar:false,
        surveys: [],
        connectedM1SurveyId: -1,
        showEvaluation: false,
        infoTextForTrafficLight: null,
        stepTitle: [
          'Zweck bestimmen', 'Gezielt vorbereiten', 'Weiter anpassen', 'Unternehmensweit verbreiten', 'Routinen neu etablieren'
        ],
      }
    },
    computed:{
      currentChecklistId(){
        return this.$route.params.listId;
      },
      completionCount(){
        let currentSchema = this.currentChecklist.listSchema[this.e1];

        let fieldCount = currentSchema.fields[1].options.length;
        let answeredCount = 0;
        currentSchema.fields[1].options.forEach(option => {
          if(option.answer == 2)  answeredCount += 1;
        })
        return parseInt((answeredCount / fieldCount) * 100);
      },
      getRed(){
        if(this.completionCount <= 50) return "var(--red-color)";
        return "#BABABA";
      },
      getYellow(){
        if(this.completionCount > 50 && this.completionCount < 100) return "var(--yellow-color)";
        return "#BABABA";
      },
      getGreen(){
        if(this.completionCount == 100) return "var(--green-color)";
        return "#BABABA";
      },
      skipStep4(){
        let val = this.$route.query.skipStep4;
        return val == null ? false:val;
      },
      mod1surveyId(){
        return this.currentChecklist.mod1surveyId;
      }
    },
    watch:{
      e1() {
        if(this.e1 == 1 && this.currentChecklist.mod1surveyId == -1){
         
        }
      }
    },
    mounted(){
      
      checklistService.getListById(this.currentChecklistId).then(res => {
        this.currentChecklist = res.data;
        this.connectedM1SurveyId = this.currentChecklist.mod1surveyId;
        this.currentChecklist.listSchema = JSON.parse(this.currentChecklist.listSchema);
        this.e1 = this.currentChecklist.listSchema.filter(elem => elem != null && this.overallCompletionCount(elem) == 100).length + 1;
        if(this.e1 >= this.currentChecklist.listSchema.length) this.e1 = 1;
        if(this.skipStep4 && this.currentChecklist.listSchema.length == 6){
          this.currentChecklist.listSchema.splice(4,1);
        }
          this.checklistLoaded = true;
      });
      this.infoTextForTrafficLight = checklistGenerator.infoTextForTrafficLight;
    },
    methods:{
        decodeModuleNameByNumber: decodeModuleNameByNumber,
        overallCompletionCount(list){
          let fieldCount = list.fields[1].options.length;
          let answeredCount = 0;
          list.fields[1].options.forEach(option => {
            if(option.answer == 2)  answeredCount += 1;
          })
          return parseInt((answeredCount / fieldCount) * 100);
        },
        hideEvaluation(){
          this.showEvaluation = false;
          this.changeStep();
        },
        nextStep(){
          this.$refs.evalDialog
          .open()
          .then(() => {
            this.showEvaluation = true;
            /* surveyService.createEvaluationTimestamp(this.surveyId).then(() => {
              
            }) */
            
          })
          .catch(e => this.changeStep())
          
        },
        async changeStep(){
          this.saveChecklist();
          if(this.e1+1 > this.currentChecklist.listSchema.length-1){
            this.$router.push({name: 'finishList', params: {
                checklistTitle: this.currentChecklist.name,
                listId: this.currentChecklistId
              }})
          }else{
            this.e1 += 1;
          } 
          window.scrollTo(0,0);
        },
        backStep(){
          this.e1 -= 1;
        },
        saveChecklist(){
          checklistService.updateChecklist(this.currentChecklist.id, this.currentChecklist.listSchema).then(res => {
            this.snackbar = true;
          })
        },
        getLabel(index){
          if(index == 4 && this.currentChecklist.listSchema.length == 5) return 5;
          return index;
        },
      showInfoBox(refPrefix, idx, infoText) {
        let selectedComponent = this.$refs[refPrefix + idx];

        if (Array.isArray(selectedComponent)) {
          return selectedComponent[0].open(infoText);
        } else {
          return selectedComponent.open(infoText);
        }
      },
      hideInfoBox(refPrefix, idx, infoText) {
        let selectedComponent = this.$refs[refPrefix + idx];

        if (Array.isArray(selectedComponent)) {
          return selectedComponent[0].close(infoText);
        } else {
          return selectedComponent.close(infoText);
        }
      },
      connectSurvey(mod){
        if(mod == 1 && this.currentChecklist.mod1surveyId != -1) return;
        if(mod == 2 && this.currentChecklist.mod2surveyId != -1) return;

        this.$refs.connectDialog
        .open(
          "Verknüpfen Sie eine Umfrage", mod
        )
        .then((data) => {
          if(data.surveyId != -1){
            checklistService.updateConnectedSurvey(this.currentChecklist.id, data.surveyId, data.module).then(() => {
              if(data.module == 1){
                this.currentChecklist.mod1surveyId = data.surveyId;
              }else if(data.module == 2){
                this.currentChecklist.mod2surveyId = data.surveyId;
              }
            });
          }
          next();
        })
        .catch(e => next())
        },
      openConnectedSurvey(surveyId) {
          let connectedSurveyEval = this.$refs.ConnectedSurveyEval;
          connectedSurveyEval.open(surveyId)
      }

    },
    beforeRouteLeave (to, from , next) {
      this.$refs.confirmDialog
      .open(
        "Speichern Sie Ihre Arbeit",
        "Möchten Sie die Änderungen speichern, bevor Sie die Seite verlassen?"
      )
      .then(() => {
        this.saveChecklist();
        next();
      })
      .catch(e => next())
    },
  }
</script>

<style scoped>
.v-toolbar {
  position: sticky;
  top: 0;
  z-index: 99;
}
:deep .v-stepper__step__step.primary {
  background-color: var(--gray-color) !important;
}
:deep .v-stepper__step {
  padding: 0;
  font-weight: 600;
  opacity: .8;
}
:deep .v-stepper__label {
  line-height: 1.2rem;
}
:deep .v-stepper__step--active {
  opacity: 1;
}
:deep .v-stepper__step--active > .v-stepper__step__step.primary {
  background-color: var(--v-secondary-base) !important;
  font-weight: 700;
}
:deep .v-stepper__step--active .v-stepper__label {
  font-weight: 700;
}
.trLight{
  height: 88px;
  width: 38px;
  position: fixed;
  background-color: #EBEBEB;
  border-radius: 5px;
  right: 0px;
  top: calc(70% - 50px);
}
.trLight-wrapper {
  margin: 5px 0;
}
.dot {
  height: 20px;
  width: 20px;
  margin: 1px 6px;
  border-radius: 50%;
  display: inline-block;
}
.v-tooltip__content {
  max-width: 400px;
}
.btn-small {
  font-size: 1.4vmin !important;
}
.survey-group {
  position: relative;
}
.survey-group::before {
  position: absolute;
  content: 'Umfragen';
  left: 10px;
  top: -6px;
  font-size: 1.1vmin;
  color: var(--gray-color_3);
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 1px;
  background-color: #fff;
  height: 15px;
}
.spacer-light {
  flex-grow: 0.5 !important;
}
.stepper-nav {
  box-shadow: unset;
  border-radius: 10px;
  padding: 0 3vw;
  margin-top: 16px;
  flex-wrap: nowrap;
  align-items: center;
}
.text-emp {
  color: var(--v-primary-base);
}
.btn-group__bottom {
  display: flex;
  justify-content: space-between;
}

@media screen and (min-width: 1800px) {
  .trLight{
    height: 110px;
    width: 46px;
    right: 15px;
    top: calc(80% - 50px);
  }
  .trLight-wrapper {
    margin: 8px 0;
  }
  .dot {
    height: 25px;
    width: 25px;
    margin: 1px 10px;
  }
}
</style>